import type { Styles } from '@adornis/ass/style.js';
import { XButton } from '@adornis/chemistry/elements/components/x-button.js';
import { customElement, property } from 'lit/decorators.js';

@customElement('exd-timebar-button')
export class ExdTimebarButton extends XButton {
  @property({ attribute: true, reflect: true }) width: string = '100%';
  @property({ attribute: true, reflect: true }) padding: string = '0 8px';
  @property({ attribute: true, reflect: true }) override tone: 'success' | 'warning' | 'error' | 'subtle' | '' = '';

  protected override stylesModeActionAndOutline = (): Styles => ({
    padding: this.padding,
    width: this.width,
    borderWidth: '1px',
    borderStyle: 'solid',
    '#innerwrapper': {
      height: `30px`,
    },
  });

  constructor() {
    super();

    this.visualStyles = () => ({
      ':host': {
        borderRadius: this.sizes.borderRadius,
        '#innerwrapper': { padding: `none`, flex: '1', position: 'relative' },
        '&[disabled]': { opacity: '.5', pointerEvents: 'none' },
        '&[loading]': { pointerEvents: 'none', filter: 'grayscale(.5)', opacity: 0.5 },
        transition: 'opacity .12s ease',
        '&:hover': { opacity: 0.9 },
        '&:active': { opacity: 0.7 },
      },
    });
  }
}
